var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMyOrders = function SvgMyOrders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.675,
    height: 41.057,
    viewBox: "0 0 33.675 41.057",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093",
    transform: "translate(1035.888 -268.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M-1030.953,273.336V269.5h23.805v3.836",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M-1031.011,295.9V277.451a1.257,1.257,0,0,1,1.254-1.253h21.415a1.256,1.256,0,0,1,1.252,1.253V295.5",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1165",
    "data-name": "Rectangle 1165",
    width: 27,
    height: 3.884,
    transform: "translate(-1032.5 299.055)",
    strokeWidth: 2.5,
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    x2: 23.283,
    transform: "translate(-1030.692 280.038)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    x2: 23.283,
    transform: "translate(-1030.692 288.845)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M-1006.96,282.873h3.5v5.994h-3.5",
    fill: "none",
    stroke: "#06016c",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M-1031.141,282.873h-3.5v5.994h3.5",
    fill: "none",
    stroke: "#06016c",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    x2: 11.084,
    transform: "translate(-1024.584 294.5)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M-1024.559,302.99v3.724a1.347,1.347,0,0,1-1.343,1.343h-1.908a1.347,1.347,0,0,1-1.343-1.343V302.99",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M-1008.559,302.99v3.724a1.346,1.346,0,0,1-1.343,1.343h-1.908a1.347,1.347,0,0,1-1.343-1.343V302.99",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyOrders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MyOrders.f26f046c.svg";
export { ForwardRef as ReactComponent };